var _style, _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#2E3192;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#21418C;}\n\t.st2{fill:#CE2028;}\n\t.st3{fill:#F1F0F0;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 10,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,17.8C12.1,17,8,17,4,17.8C4.6,12.6,4.6,7.4,4,2.2c4.4,3.4,8.1,5.2,11.9,7.8H8.4 C10.8,12.4,13.1,14.7,16.1,17.8L16.1,17.8z M4.6,17.1c3.3-0.5,6.7-0.6,10-0.2c-2.8-2.8-5.1-5-7.5-7.5c2.3,0,4.7,0,7,0 c-3-1.9-6-3.6-9.3-6.1c0.4,4.6,0.4,9.2,0,13.8L4.6,17.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.3,2.8c0.5,4.9,0.5,9.8,0,14.7c3.6-0.6,7.4-0.7,11-0.1c-2.9-2.9-5.2-5.2-7.6-7.6c2.4,0,4.8,0,7.2,0 C11.6,7.4,8.2,5.7,4.3,2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.3,9.3c1.1,0,2-0.9,2-2v0C9.1,7.8,8.8,8.2,8.4,8.4L8.2,8.3L8.6,8L8.1,7.9l0,0c0.1-0.1,0.1-0.2,0.2-0.4 L7.9,7.6L8,7.1L7.6,7.3l0,0L7.5,6.9L7.3,7.2L7,6.9C7,7,6.9,7.2,6.9,7.3l0,0L6.5,7.1c0,0.1,0,0.3,0.1,0.4L6.2,7.4l0.2,0.4l0,0L6,7.9 l0.3,0.3L6.2,8.3C5.7,8,5.4,7.6,5.2,7.1C5.2,8.3,6.1,9.3,7.3,9.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.6,13.7L8.6,13.7l0.9-0.4L8.6,13l0,0c0.2-0.2,0.4-0.5,0.6-0.8l-0.9,0.1l0,0l0.1-0.9L7.6,12l0,0 c-0.1-0.3-0.2-0.6-0.3-0.9C7.1,11.4,7,11.7,6.9,12l0,0l-0.7-0.6l0.1,0.9l-0.9-0.1l0.5,0.7l0,0L5,13.5l0.8,0.3l0,0 c-0.2,0.3-0.4,0.6-0.6,0.8l1-0.2l0,0c0,0.3-0.1,0.6-0.2,1l0.8-0.6l0,0l0.3,0.8l0.4-0.9l0,0l0.7,0.5l-0.1-0.9l0.9,0.1L8.6,13.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.533598bff404458199eb3a023bbe5b6c.svg";
export { ForwardRef as ReactComponent };